import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useApi from 'helpers/api';
import { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ServiceGroupService from "services/ServiceGroup.service";

const ServiceCatalogEditModal = ({ showModal, data, handleClose, handleSubmit, refreshData, error }) => {
  const api = useApi();
  const [body, setBody] = useState({
    name: '',
    inactive: false
  });
  const [validated, setValidated] = useState(false);
  const [serviceGroups, setServiceGroups] = useState({ content: [] });
  const [associatedServiceGroups, setAssociatedServiceGroups] = useState([]);
  const [selectedServiceGroup, setSelectedServiceGroup] = useState('');
  const [filters] = useState({ size: 100 });
  const queryParams = new URLSearchParams(filters).toString();
  const form = useRef(null);

  useEffect(() => {
    if (Object.keys(data).length != 0) {
      setBody({
        name: data.name || '',
        inactive: data.inactive || false
      });
      setValidated(false);
      getAssociatedServiceGroups();
    }
  }, [data]);

  useEffect(() => {
    if (showModal) {
      setValidated(false);
    }
  }, [showModal]);

  useEffect(() => {
    const getServiceGroups = async () => {
      let response = await ServiceGroupService.listSummaryData(queryParams);
      if (response.content) setServiceGroups(response);
    };

    getServiceGroups();
  }, []);

  const onSubmit = e => {
    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      handleSubmit({
        name: body.name,
        inactive: body.inactive
      });
      setValidated(false);
    }
  };

  const getAssociatedServiceGroups = async () => {
    let response = await api.serviceCatalogsServiceGroups.list(data.id);
    setAssociatedServiceGroups(response);
  };

  const associateServiceGroup = async e => {
    e.preventDefault();
    let response = await api.serviceCatalogsServiceGroups.associate(data.id, selectedServiceGroup);
    if (response.status == 204) {
      refreshData();
      getAssociatedServiceGroups();
    } else {
      error(response);
    }
  };

  const unassociateServiceGroup = async (e, id) => {
    e.preventDefault();
    let response = await api.serviceCatalogsServiceGroups.unassociate(data.id, id);
    if (response.status == 204) {
      refreshData();
      getAssociatedServiceGroups();
    } else {
      error(response);
    }
  };

  return (
    <>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Editar catálogo de serviço</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form validated={validated} ref={form}>
            <Form.Group className="mb-3" controlId="editForm.Name">
              <Form.Label>Nome</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nome"
                autoFocus
                value={body.name}
                onChange={e => setBody((prevBody) => ({ ...prevBody, name: e.target.value }))}
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">Insira um nome.</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editForm.Status">
              <Form.Label>Status</Form.Label>
              <Form.Check
                type="switch"
                id="status-switch"
                label={body.inactive ? 'Inativo' : 'Ativo'}
                checked={!body.inactive}
                onChange={(e) => setBody((prevBody) => ({ ...prevBody, inactive: !e.target.checked }))}
              />
            </Form.Group>

            <Form.Label>Associe um grupo de serviço</Form.Label>
            <Form.Group className="w-100 d-flex justify-content-between">
              <Form.Select aria-label="Grupos de serviço" className="flex-1 me-2" onChange={e => setSelectedServiceGroup(e.target.value)}>
                <option>Selecione uma opção</option>
                {serviceGroups.content.map((item, i) => (
                  <option value={item.id} key={i}>{item.name}</option>
                ))}
              </Form.Select>
              <button className="btn btn-primary btn-sm" onClick={associateServiceGroup}>
                + Adicionar
              </button>
            </Form.Group>
          </Form>
          <div className="table-responsive scrollbar">
            <table className="table fs-10 mb-0 mt-3">
              <thead className="bg-200 text-900">
                <tr>
                  <th>Grupos de serviço</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {associatedServiceGroups.map((item, i) => (
                  <tr key={i}>
                    <td data-value={item.id}>{item.name}</td>
                    <td>
                      <button className="btn btn-link text-danger btn-sm" onClick={e => unassociateServiceGroup(e, item.id)}>
                        x
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="falcon-default" onClick={handleClose}>
            Fechar
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            <FontAwesomeIcon icon={faSave} className="me-2" />
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServiceCatalogEditModal;